module.exports = __webpack_public_path__ + "static/media/legly_logo_color.36fc6bcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/legly_logo_color.svg
// module id = 39
// module chunks = 0